export const GA_EVENTS = {
	ADD_TO_CART: "add_to_cart",
	REMOVE_FROM_CART: "remove_from_cart",
	PURCHASE: "purchase",
	VIEW_ITEM: "view_item",
	BAG_VIEW: "bag_view",
	BEGIN_CHECKOUT: "begin_checkout",
	PAGE_VIEW: "page_view",
	SELECT_CONTENT: "select_content",
	NAVIGATION_CLICK: "navigation_click",
}
